module.exports = __webpack_public_path__ + "static/media/w (36).0a07c292.jpg";